import { render } from "./InputVideo.vue?vue&type=template&id=868445c6&scoped=true"
import script from "./InputVideo.vue?vue&type=script&lang=js"
export * from "./InputVideo.vue?vue&type=script&lang=js"

import "./InputVideo.vue?vue&type=style&index=0&id=868445c6&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-868445c6"]])

export default __exports__